import { scCoreModule } from '../core/core.module';
import { DatePickerComponent } from './date-picker.component';
import { FilterDimensionComponent } from './filter-dimension.component';
import { FilterDimensionNodeComponent } from './filter-dimension-node.component';
import { FilterEditorModalService } from './editor/filter-editor-modal.service';
import { CatalogComponent } from './catalog/catalog.component';
import { CatalogNodeComponent } from './catalog/catalog-node.component';
import { FilterSearchComponent } from './filter-search.component';
import { FilterDimensionsComponent } from './filter-dimensions.component';
import { FilterDrilldownComponent } from './filter-drilldown.component';
import { FilterCardEditorModalService } from './editor/filter-card-editor-modal.service';
import { AlertModalService } from './editor/alert-modal.service';
import { QueryBuilderComponent } from './query-builder/query-builder.component';
import { FilterValueInputComponent } from './query-builder/filter-value-input.component';
import { QueryBuilderNodeComponent } from './query-builder/query-builder-node.component';
import { FilterEditorService } from './editor/filter-editor.service';
import { FilterCardEditorCellComponent } from './editor/filter-card-editor-cell.component';

export const scFilterModule = 'sc-filter';

angular.module(scFilterModule, [scCoreModule])
  .service('FilterEditorService', FilterEditorService)
  .service('FilterEditorModalService', FilterEditorModalService)
  .service('FilterCardEditorModalService', FilterCardEditorModalService)
  .service('AlertModalService', AlertModalService)
  .component('scDatePicker', DatePickerComponent)
  .component('scCatalog', CatalogComponent)
  .directive('scCatalogNode', CatalogNodeComponent)
  .component('scFilterDimension', FilterDimensionComponent)
  .component('scFilterDimensionNode', FilterDimensionNodeComponent)
  .directive('scFilterDimensions', FilterDimensionsComponent)
  .directive('scFilterSearch', FilterSearchComponent)
  .component('scFilterDrilldown', FilterDrilldownComponent)
  .component('scQueryBuilder', QueryBuilderComponent)
  .component('scQueryBuilderNode', QueryBuilderNodeComponent)
  .component('scFilterValueInput', FilterValueInputComponent)
  .component('scFilterCardEditorCell', FilterCardEditorCellComponent)
;



// WEBPACK FOOTER //
// ./src/filter/filter.module.js